import PubSub from "underpub-js";
import gsap from "gsap";
import { find } from "underscore";

var ModalCodeEmbed = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ModalCodeEmbed',
	};

	$.extend(true, this.options, options);

};

ModalCodeEmbed.prototype.init = function() {

	var self = this;

	self.modalId = self.options.$el.data('modalId');

	self.$embedWrapper = self.options.$el.find(`.${self.options.baseClass}__embedWrapper`);
	self.$embedWrapperBackdrop = self.options.$el.find(`.${self.options.baseClass}__embedWrapper__backdrop`);
	self.$embed = self.options.$el.find(`.${self.options.baseClass}__embed`);
	self.$iframe = self.options.$el.find('iframe');
	self.$closeButton = self.options.$el.find(`.${self.options.baseClass}__closeButton .atom-ButtonIcon`);

	self.sizeIFrame();
	self.initAnimationTimelines();
console.log('modal');
console.log(self.modalId);
	$('[href="#open-embed-modal-'+self.modalId+'"]').on('click', function() {
		self.animateIn();
	});

	self.$closeButton.on('click', function() {
		self.animateOut();
	});

};

ModalCodeEmbed.prototype.initAnimationTimelines = function() {

	const self = this;

	self.animateInTimeline = gsap
		.timeline({
			paused: true,
			defaults: {
				ease: "power2.out",
				duration: 0.6,
			}
		})
		.set(self.options.$el, {
			zIndex: 1000,
			visibility: 'visible',
		})
		.fromTo(self.options.$el, 
			{
				opacity: 0
			},
			{
				ease: "power4.out",
				duration: 0.7,
				opacity: 1
			}
		)
		.fromTo(self.$embedWrapper,
			{
				x: -16,
				y: -16,
			},
			{
				x: 0,
				y: 0,
			},
			">-=0.5"
		)
		.fromTo(self.$embedWrapperBackdrop,
			{
				x: 32,
				y: 32,
			},
			{
				x: 0,
				y: 0,
			},
			"<"
		);

	self.animateOutTimeline = gsap
	.timeline({
		paused: true,
		defaults: {
			ease: "power3.out",
			duration: 0.6,
		}
	})
	.fromTo(self.options.$el, 
		{
			opacity: 1
		},
		{
			opacity: 0
		}
	)
	.set(self.options.$el, {
		zIndex: -1,
		visibility: 'hidden',
	});

};

ModalCodeEmbed.prototype.sizeIFrame = function() {

	var self = this;

	let padding = 56.25;

	if (self.$iframe.length) {

		let width = self.$iframe.attr('width');
		let height = self.$iframe.attr('height');

		if (width && height) {
			padding = (height / width) * 100;
		}
	
		self.$iframe.attr('width', '');
		self.$iframe.attr('height', '');

	}

	self.$embed.css('padding-bottom', padding+'%');

};

ModalCodeEmbed.prototype.animateIn = function() {
	
	const self = this;

	self.animateInTimeline.restart();

};

ModalCodeEmbed.prototype.animateOut = function() {
	
	const self = this;

	self.animateOutTimeline.restart();

};

export default ModalCodeEmbed;
